export default __webpack_public_path__ + "static/media/banner1.0ddc4d9d.jpg";